export const setToken = (newToken: string) => {
    localStorage.setItem('token', newToken);
};

export const getToken = () => {
    return localStorage.getItem('token') || '';
};

export const deleteToken = () => {
    localStorage.removeItem('token');
};